import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_incredi_icon_button = _resolveComponent("incredi-icon-button")!

  return (_openBlock(), _createBlock(_component_incredi_icon_button, _mergeProps({ class: { 'cloud-icon-image': true } }, _ctx.attrs, {
    "data-testid": "cloud-notification-button",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'settings.Cloud' })))
  }), {
    default: _withCtx(() => [
      (_ctx.showTooltip)
        ? (_openBlock(), _createBlock(_component_q_tooltip, {
            key: 0,
            modelValue: _ctx.show,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
            class: "cloudStatusTooltip",
            "content-class": "tooltip-background gordita-500-11-m",
            anchor: "bottom middle",
            self: "top middle",
            offset: [10, 5],
            "data-testid": "cloud-notification-button-tooltip"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.getTooltipText), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}